module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-9"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Contents"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01b#ab_01b",
      "id": "ba_01b",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ebook Instructions")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz9-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#ab_02",
      "id": "ba_02"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz9-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#ab_04",
      "id": "ba_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 1: Make the End the Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "A-C"
    }
  }, [_c('em', [_vm._v("The questions we ask at the end of life are the ones we should begin with.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz9-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#ab_05",
      "id": "ba_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 2: Recognize Everything Is God’s")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "AQ7"
    }
  }, [_c('em', [_vm._v("Generosity and legacy happen only when we return everything to the rightful owner.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz9-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#ab_07",
      "id": "ba_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 3: Put People Before Profit")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "Ay"
    }
  }, [_c('em', [_vm._v("Choose the eternal in the everyday mundane.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz9-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ab_08",
      "id": "ba_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 4: Consider All the Blessings You’ve Been Given")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "AKp"
    }
  }, [_c('em', [_vm._v("The greatest blessings are the ones that can never be lost.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz9-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ab_09",
      "id": "ba_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 5: Develop a Vision for Generosity")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "ADG"
    }
  }, [_c('em', [_vm._v("Every journey requires a destination.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz10-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ab_10",
      "id": "ba_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 6: Create a Plan for Generosity")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "AKk"
    }
  }, [_c('em', [_vm._v("Those who plan to give, do.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz10-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ab_11",
      "id": "ba_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 7: Talk About Money with Your Children")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "ALg"
    }
  }, [_c('em', [_vm._v("What you know, you can change. What you don’t know controls you.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz10-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ab_12",
      "id": "ba_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 8: Give Even When It Seems Impossible")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "Azl"
    }
  }, [_c('em', [_vm._v("You won’t know whether you can out-give God until you try.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz10-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#ab_13",
      "id": "ba_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 9: Create a Family Legacy Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "AIp"
    }
  }, [_c('em', [_vm._v("Passing on wealth means passing on all forms of wealth.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz10-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#ab_14",
      "id": "ba_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 10: Stockpile Treasure in Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "AqN"
    }
  }, [_c('em', [_vm._v("Legacy is not just what we leave behind, but what we send ahead.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz10-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#ab_15",
      "id": "ba_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "Ard"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#ab_16",
      "id": "ba_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "Ai0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#ab_17",
      "id": "ba_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("My Family Legacy Plan")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c457de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content-toc.vue
// module id = 72
// module chunks = 0